import type {
	PlayerAuctionDecideListedInput,
	PlayerAuctionDecideSuggestedInput,
	PlayerAuctionInitiateSellingInput,
	PlayerAuctionPlayersPictureInput,
	PlayerAuctionRecentInput,
	PlayersAuctionInitInput,
	adminPlayersAuctionInput,
	getPlayersAuctionFacetsInput,
	playersAuctionInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetAdminPlayersAuction: adminPlayersAuctionInput;
	useGetPlayersAuction: playersAuctionInput;
	useGetPlayersAuctionFacets: getPlayersAuctionFacetsInput;
	useGetPlayersAuctionInit: PlayersAuctionInitInput;
	useGetPlayerAuctionRecent: PlayerAuctionRecentInput;
	usePlayersAuctionInitiateSelling: PlayerAuctionInitiateSellingInput;
	usePlayersAuctionDecideSuggestedPlayer: PlayerAuctionDecideSuggestedInput;
	usePlayersAuctionDecideListedPlayer: PlayerAuctionDecideListedInput;
	useGetPlayersPictures: PlayerAuctionPlayersPictureInput;
}

const PLAYERS_AUCTION_KEYS = createReactQueryKeys<Keys>("playersAuction", [
	"useGetAdminPlayersAuction",
	"useGetPlayersAuction",
	"useGetPlayersAuctionFacets",
	"useGetPlayersAuctionInit",
	"useGetPlayerAuctionRecent",
	"usePlayersAuctionInitiateSelling",
	"usePlayersAuctionDecideSuggestedPlayer",
	"usePlayersAuctionDecideListedPlayer",
	"useGetPlayersPictures",
]);

export { PLAYERS_AUCTION_KEYS };
